<template>
  <div>
    <div class="text-h5">Documentation</div>
    <hr />
    <div>
      The <b>Certificate Configuration Generator</b> will generate the <b>XML Configuration</b> needed to add a <b>Certificate Generator LTI Tool</b> to your <b>Canvas Course</b>.
      Students will then be able to generate a <b>Certificate of Completion</b> once they have a passing score for the given <b>Quiz ID</b>.

      <br /><br />
      <div class="text-subtitle2">Generating the XML</div>
      To get started, log in on the <a href="https://ucdenver.instructure.com/" target="_blank">Canvas Portal</a>.
      <ol>
        <li>
          Navigate to the Course where you want to add the <b>Certificate Generator LTI Tool</b>
        </li>
        <li>
          Select <b>Quizzes</b> and choose the <b>quiz</b> that must be passed to recieve a <b>Certificate of Completion</b>
        </li>
        <li>
          Copy the <b>Course ID</b> and <b>Quiz ID</b> from the URL (see image below).
          <ul>
            <li>
              <b>Course ID</b> is the first number after /courses/ in the URL.
            </li>
            <li>
              <b>Quiz ID</b> is the number after the last slash in the URL
            </li>
          </ul>
        </li>
        <li>
          Add the <b>Minimum Score Required</b> that a student must achieve to recieve a <b>Certificate of Completion</b>.
          <br />
          <b class="text-red">This is the minimum number of correct answers (e.g. 5)</b>
        </li>
        <li>
          After clicking <b>Generate</b>, the <b>XML Configuration URL</b> will be shown below the form.  Copy this URL somewhere temporary.
        </li>
      </ol>
      <q-img
        src="@/assets/quiz_url_example.png"
        alt="Quiz Url Example"
        style="max-width: 580px;"
      />
      <br /><br />
      <div class="text-subtitle2">Adding the Certificate Generator LTI Tool</div>
      <ol>
        <li>
          Open the <a href="https://ucdenver.instructure.com/accounts/1/developer_keys" target="_blank">Developer Keys</a> page and look for a <b>Key</b>
          with the name <b>Wolf Certificate</b>.  Copy the ID and Key somewhere temporary.
        </li>
        <li>
          Navigate to the course where you want to add the <b>Certificate Generator LTI Tool</b>.
        </li>
        <li>
          Click <b>Settings</b> on the bottom-left-hand navigation sidebar.  Click <b>Apps</b>
          then <b>View App Configurations</b>.  Finally, click on the <b>+ App</b> button.
        </li>
        <li>
          In the App configuration popup, add the following and <b>Submit</b>:
          <ul>
            <li>
              Configuration Type: <b>By URL</b>
            </li>
            <li>
              Name: <b>The name you want to identify this app by.</b>
            </li>
            <li>
              Config URL: The copied <b>Configuration URL</b>.
            </li>
            <li>
              Consumer Key: The copied <b>Consumer Key</b> (e.g. 10430000000000315).
            </li>
            <li>
              Shared Secret: The copied <b>Secret</b> (e.g. 2M4qujywdM3xyf5pyFvJ...).
            </li>
          </ul>
        </li>
        <li>
          Get Certificate will now show as a link in the left-hand navigation sidebar.
        </li>
      </ol>

      <q-img
        src="@/assets/new_link.png"
        alt="Link Example"
        style="max-width: 195px;"
      />
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'

export default {
  name: 'config-documentation',
  components: {
  },

  setup () {
    const state = reactive({
      isLoading: false
    })

    return state
  }
}
</script>
